import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { authenticate, updateModifiedDate } from '../../api/legacy';
import { authenticateLegacy } from '../../api/authentication';
import {
  loadAnnotations,
  saveAnnotations,
  retrieveExportData
} from '../../api/annotation';
import queryString from 'query-string';

interface AnnotationImportState {
  presets: Record<string, any>;
  userId: string;
  error?: boolean;
  errorMessage?: any;
}

export function AnnotationImport() {
  const params = useParams();
  const location = useLocation();
  const [state, setState] = useState<AnnotationImportState>({
    presets: {},
    userId: ''
  });

  useEffect(
    () => {
      const loadData = async () => {
        const parsed = queryString.parse(location.search);
        const client = params.client;
        const applicationSessionId = parsed.appSessionId;
        const sessionId = parsed.sessionId;

        try {
          const exportData = await retrieveExportData();

          for (let i = 0; i < exportData.length; i++) {
            const { docid, page, text, creationtime, user } = exportData[i];
            try {
              let tmpAnnotations = null;
              let annotations = null;
              await authenticate(
                client,
                docid,
                applicationSessionId,
                sessionId
              );

              const response = await authenticateLegacy(
                client,
                docid,
                applicationSessionId,
                sessionId
              );
              const token = response.token;

              tmpAnnotations = await loadAnnotations(token, client, docid);

              if (
                tmpAnnotations !== null &&
                tmpAnnotations.instantJson &&
                tmpAnnotations.instantJson.annotationJSON
              ) {
                annotations = tmpAnnotations.instantJson.annotationJSON;
                if (annotations.pdfId) {
                  annotations.pdfId = null;
                }
              } else {
                annotations = {
                  annotations: [],
                  format: 'https://pspdfkit.com/instant-json/v1',
                  pdfId: null
                };
              }

              let z = 0;
              for (
                let index = 0;
                index < annotations.annotations.length;
                index++
              ) {
                if (annotations.annotations[index].pageIndex === page) {
                  z++;
                }
              }
              let y = z * 40;
              annotations.annotations.push({
                bbox: [5, y, 24, 24],
                color: '#FFD83F',
                createdAt: creationtime,
                icon: 'comment',
                id: new Date().getTime() + i + '',
                name: new Date().getTime() + i + '',
                opacity: 1,
                pageIndex: page,
                text: text,
                type: 'pspdfkit/note',
                updatedAt: new Date().getTime(),
                v: 1,
                creatorName: user
              });

              internalSaveAnnotations(annotations, token, docid);
            } catch (error) {
              console.log('caught error');
              if (docid) {
                console.log('error docid', docid);
              }
              console.log('error index', i);
            }
          }
        } catch (error) {
          console.log('caught error');
          console.log(error);
          setState(prevState => ({
            ...prevState,
            error: true,
            errorMessage: error
          }));
        }
      };

      const internalSaveAnnotations = (instantJson, token, documentId) => {
        const client = params.client;
        saveAnnotations(token, client, documentId, instantJson);
        const parsed = queryString.parse(location.search);
        const applicationSessionId = parsed.appSessionId;
        const sessionId = parsed.sessionId;
        updateModifiedDate(client, documentId, applicationSessionId, sessionId);
      };

      loadData();
    },
    [location.search, params]
  );

  let errorDisplay = null;
  if (state.error) {
    errorDisplay = <span>{state.errorMessage}</span>;
  }
  return <div>{errorDisplay}</div>;
}

export default AnnotationImport;
